import { render } from "./ArrivalDeclarationStatusFieldsetGroup.vue?vue&type=template&id=007408d1"
import script from "./ArrivalDeclarationStatusFieldsetGroup.vue?vue&type=script&lang=js"
export * from "./ArrivalDeclarationStatusFieldsetGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__